import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientTimesheetsPage from "@/pages/client/ClientTimesheetsPage";

export const Route = createFileRoute("/client/contracts/$contractId/timesheets")({
  head: () => pageHead("Client · Contracts · Timesheets", "AKIVA client · contracts · timesheets portal.", "/client/contracts/$contractId/timesheets", true),
  component: ClientTimesheetsPage,
});
